export enum BlockAlign {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  STRETCH = 'stretch',
}

export enum BlockJustify {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  SPACE_BETWEEN = 'space-between',
  SPACE_AROUND = 'space-around',
  SPACE_EVENLY = 'space-evenly',
}

export enum BlockHeight {
  NORMAL = 'normal',
  TALL = 'tall',
}

interface BlockSettings {
  align?: BlockAlign;
  justify?: BlockJustify;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockSettings {
  export function make(align: BlockAlign, justify: BlockJustify): BlockSettings {
    return {
      align,
      justify,
    };
  }

  export function getDefault(align = BlockAlign.CENTER, justify = BlockJustify.CENTER): BlockSettings {
    return {
      align,
      justify,
    };
  }

  export function toBootstrapJustifyClass(justify?: BlockJustify): string {
    switch (justify) {
      case BlockJustify.START:
        return 'justify-content-start';
      case BlockJustify.END:
        return 'justify-content-end';
      case BlockJustify.SPACE_BETWEEN:
        return 'justify-content-between';
      case BlockJustify.SPACE_AROUND:
        return 'justify-content-around';
      case BlockJustify.SPACE_EVENLY:
        return 'justify-content-evenly';
      case BlockJustify.CENTER:
      default:
        return 'justify-content-center';
    }
  }
}

export default BlockSettings;
